import { render, staticRenderFns } from "./item-gallery-full.vue?vue&type=template&id=6e292d04&scoped=true&"
import script from "./item-gallery-full.vue?vue&type=script&lang=js&"
export * from "./item-gallery-full.vue?vue&type=script&lang=js&"
import style0 from "./item-gallery-full.vue?vue&type=style&index=0&id=6e292d04&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e292d04",
  null
  
)

export default component.exports